const ACTIONS = {
    FETCH_URGENCY_MESSAGE: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE',
    FETCH_URGENCY_MESSAGE_SUCCESS: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE_SUCCESS', // => reducer
    FETCH_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_BADGES_SUCCESS',
    FETCH_BY_OWNER_PROPERTIES: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES',
    FETCH_BY_OWNER_PROPERTIES_SUCCESS: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES_SUCCESS',
    FETCH_BY_OWNER_PROPERTIES_FAILED: 'LISTING_EXTENDED/FETCH_BY_OWNER_PROPERTIES_FAILED',
    FETCH_INQUIRY_PROPERTIES: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES',
    FETCH_INQUIRY_PROPERTIES_SUCCESS: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES_SUCCESS',
    FETCH_INQUIRY_PROPERTIES_FAILED: 'LISTING_EXTENDED/FETCH_INQUIRY_PROPERTIES_FAILED',
    FETCH_RANKED_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_RANKED_BADGES_SUCCESS',
    FETCH_PRICING_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_PRICING_BADGES_SUCCESS',
    FETCH_SUPERLATIVE_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_SUPERLATIVE_BADGES_SUCCESS',
    FETCH_DISCOVERY_SUCCESS: 'LISTING_EXTENDED/FETCH_DISCOVERY_SUCCESS',
    FETCH_UNIT_SPACES_SUCCESS: 'LISTING_EXTENDED/FETCH_UNIT_SPACES_SUCCESS',
    FETCH_HOUSE_RULES_SUCCESS: 'LISTING/EXTENDED/FETCH_HOUSE_RULES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES: 'LISTING/EXTENDED/FETCH_RECOMMENDED_PROPERTIES',
    FETCH_RECOMMENDED_PROPERTIES_SUCCESS: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES_FAILED: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_FAILED',
    FETCH_REGISTRATION_NUMBER_SUCCESS: 'LISTING/FETCH_REGISTRATION_NUMBER_SUCCESS',
    FETCH_GEO_DISTANCE_SUCCEES: 'LISTING/FETCH_GEO_DISTANCE_SUCCEES',
    FETCH_THINGS_OF_INTEREST_SUCCESS: 'LISTING/FETCH_THINGS_OF_INTEREST_SUCCESS'
};

const ACTION_CREATORS = {
    fetchUrgencyMessage() {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE
        };
    },
    fetchUrgencyMessageSuccess(urgencyMessage) {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE_SUCCESS,
            payload: {
                urgencyMessage
            }
        };
    },
    fetchRankedBadgesSuccess(rankedBadges) {
        return {
            type: ACTIONS.FETCH_RANKED_BADGES_SUCCESS,
            payload: {
                rankedBadges
            }
        };
    },
    fetchPricingBadgesSuccess(pricingBadges) {
        return {
            type: ACTIONS.FETCH_PRICING_BADGES_SUCCESS,
            payload: {
                pricingBadges
            }
        };
    },
    fetchSuperlativeBadgesSuccess(superlativeBadges) {
        return {
            type: ACTIONS.FETCH_SUPERLATIVE_BADGES_SUCCESS,
            payload: {
                superlativeBadges
            }
        };
    },
    fetchDiscoveryFeedSuccess(discoveryFeed) {
        return {
            type: ACTIONS.FETCH_DISCOVERY_SUCCESS,
            payload: {
                discoveryFeed
            }
        };
    },
    fetchUnitSpacesSuccess(unitSpaces) {
        return {
            type: ACTIONS.FETCH_UNIT_SPACES_SUCCESS,
            payload: {
                unitSpaces
            }
        };
    },
    fetchRecommendedProperties() {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES
        };
    },
    fetchRecommendedPropertiesSuccess(recommendedProperties) {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_SUCCESS,
            payload: {
                recommendedProperties
            }
        };
    },
    fetchRecommendedPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchByOwnerProperties() {
        return {
            type: ACTIONS.FETCH_BY_OWNER_PROPERTIES
        };
    },
    fetchByOwnerPropertiesSuccess(byOwnerProperties) {
        return {
            type: ACTIONS.FETCH_BY_OWNER_PROPERTIES_SUCCESS,
            payload: {
                byOwnerProperties
            }
        };
    },
    fetchByOwnerPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_BY_OWNER_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchInquiryProperties() {
        return {
            type: ACTIONS.FETCH_INQUIRY_PROPERTIES
        };
    },
    fetchInquiryPropertiesSuccess(inquiryProperties) {
        return {
            type: ACTIONS.FETCH_INQUIRY_PROPERTIES_SUCCESS,
            payload: {
                inquiryProperties
            }
        };
    },
    fetchInquiryPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_INQUIRY_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchRegistrationNumberSuccess(registrationNumber) {
        return {
            type: ACTIONS.FETCH_REGISTRATION_NUMBER_SUCCESS,
            payload: {
                registrationNumber
            }
        };
    },
    fetchGeoDistanceSuccess(geoRelativeDistances) {
        return {
            type: ACTIONS.FETCH_GEO_DISTANCE_SUCCEES,
            payload: {
                geoRelativeDistances
            }
        };
    },
    fetchThingsOfInterestSuccess(thingsOfInterest) {
        return {
            type: ACTIONS.FETCH_THINGS_OF_INTEREST_SUCCESS,
            payload: {
                thingsOfInterest
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
